import { Body1, Button, Theme } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export interface ICompareFlightOnboardingContentProps {
  onAboutComparisonClick(): void;
}

export function CompareFlightOnboardingContent({ onAboutComparisonClick }: ICompareFlightOnboardingContentProps) {
  return (
    <div className={styles['container']}>
      <Body1 color="text-inverted-default" whiteSpace="nowrap">
        Сравните этот ЖК с другими: жмите
        <br />
        плюс — соберём таблицу с выводами
        <br />в разделе «Сравнение»
      </Body1>

      <Theme theme="light">
        <Button theme="inverted" size="XS" maxWidth={138} onClick={onAboutComparisonClick}>
          О сравнении ЖК
        </Button>
      </Theme>
    </div>
  );
}
